<template>
    <div style="gap:20px" class="d-flex flex-column justify-space-between">
        <v-card style="height:200px;" class="d-flex flex-column align-center justify-center">
            <div v-if="now" class="d-flex flex-column align-center">
                <div style="font-size:3em">{{ now.toLocaleTimeString() }}</div>
                <div>
                    {{ englishDateLabel }}
                </div>
            </div>
            <div v-if="hijriDate" class="mt-2 dhivehi">
                <bdi>{{ hijriDate }}</bdi>
            </div>
        </v-card>

        <!-- <v-card style="flex: 1 0 auto;">
            <v-card-text class="pa-2">
                <div style="max-height:200px; overflow-y:auto;">
                    <v-alert dense class="mb-1" v-for="(message, mi) in messages" :key="mi" :type="message.type || 'info'" :color="message.color" :icon="message.icon || 'mdi-information-outline'">
                        {{message.text}}
                    </v-alert>
                </div>
            </v-card-text>
        </v-card> -->
    </div>
</template>

<script>
import axios from '../../plugins/axios'

export default {
    data: () => ({
        interval: null,
        now: null,
        dhivehiDate: null,
        hijriDate: null,
        messages: [],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        days: ['Sunday', 'Monday', 'Tuesday', 'WednesDay', 'Thursday', 'Friday', 'Saturday']
    }),
    computed: {
        englishDateLabel(){
            return `${this.days[this.now.getDay()]}, ${this.now.getDate()} ${this.months[this.now.getMonth()]} ${this.now.getFullYear()}`
        }
    },
    methods: {
        getData(){
            this.getDhivehiDate()
            // this.getMOTD()
        },
        getDhivehiDate(){
            axios.get(`/api/dhivehi-date`).then(res => {
                this.hijriDate = res.data.hijri
                this.dhivehiDate = res.data.dhivehi
            });
        },
        // getMOTD(){
        //     axios.get(`/api/dashboard/motd`).then(res => {
        //         this.messages = res.data
        //     })
        // },
    },
    created(){
        this.getData()
        this.interval = setInterval(() => {
            this.now = new Date()
        })
    },
    destroyed(){
        if(this.interval) clearInterval(this.interval)
    }
}
</script>